var exports = {
  "a": "labelDotsContainer__ZoDpas",
  "Q": "labelDot__-9Ax-E",
};

module.exports = exports;
